/**
 * Google Maps Map ID used for map styling and features.
 */
export const GOOGLE_MAP_ID = 'e9e6944f39d8a6d1fa94c9ed';

/**
 * Map's zoom after navigating to user geolocation
 */
export const GEOLOCATION_ZOOM = 15;

/**
 * Map's zoom for a selected station view
 */
export const SELECTED_STATION_ZOOM = 15;
